/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Binding_Do_DetailInputs */

const en_marketing_binding_do_detail = /** @type {(inputs: Marketing_Binding_Do_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realtime rooms, presence, notifications, and the AI agent.`)
};

const es_marketing_binding_do_detail = /** @type {(inputs: Marketing_Binding_Do_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salas en tiempo real, presencia, notificaciones y el agente de IA.`)
};

const fr_marketing_binding_do_detail = /** @type {(inputs: Marketing_Binding_Do_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salons temps réel, présence, notifications et agent IA.`)
};

/**
* | output |
* | --- |
* | "Realtime rooms, presence, notifications, and the AI agent." |
*
* @param {Marketing_Binding_Do_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_binding_do_detail = /** @type {((inputs?: Marketing_Binding_Do_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Binding_Do_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_binding_do_detail(inputs)
	if (locale === "es") return es_marketing_binding_do_detail(inputs)
	return fr_marketing_binding_do_detail(inputs)
});